import tableAppTransactions from './tableAppTransactions';

export default {
  tabName: 'Succesful transactions',
  title: '',
  isTable: true,
  attributeName: 'appTransaction',
  getURL: 'appId/appTransaction',
  updateURL: 'appId/appTransaction',
  createURL: '',
  removeURL: 'appId/appTransaction',
  sessionParams: ['appId'],
  noArea: true,
  tableConfig: tableAppTransactions,
  eventKey: 'successful',
  autoUpdate: true,
  updateValuesAfterUpdate: ['used'],
};
